import BankTransactionsTable from './components/BankTransactionsTable';
import UseAccountStore from '../../../stores/DataStore';
import React, {useEffect} from 'react';
import Spinner from '../../../components/spinner';
import Widget from '../../../components/widget/Widget';
import {HiOutlineCash} from 'react-icons/hi';
import {defaultDateFormatStr, formatCurrency} from '../../../stores/JSHelper';
import UseBankTransactionStore from '../../../stores/BankTransactionStore';

const BankTransactions = () => {
  const {loading, refresh, response, psp, setPsp} = UseBankTransactionStore();
  const {account} = UseAccountStore();

  useEffect(() => {
    (async () => {
      await refresh();
    })();
  }, [account]);

  if (loading) {
    return <Spinner />;
  }
  const widgets = [
    {title: 'Start Date', subtitle: `${defaultDateFormatStr(response.startDate)}`},
    {title: 'End Date', subtitle: `${defaultDateFormatStr(response.endDate)}`},
    {title: 'Deposit Count', subtitle: `${response.transactions.length}`},
    {title: 'Total Amount', subtitle: `${formatCurrency(response.totalAmount, 'INR')}`},
  ];

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-6">
        {widgets.map((d) => {
          return <Widget icon={<HiOutlineCash className="h-7 w-7" />} title={d.title} subtitle={d.subtitle} />;
        })}
      </div>

      <div className="my-5">
        <div>
          <BankTransactionsTable transactions={response.transactions.reverse()} refresh={refresh} psp={psp} setPsp={setPsp} />
        </div>
      </div>
    </div>
  );
};

export default BankTransactions;
